import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

import './CircularProgress.scss'

const SIZE = 44

const CircularProgress = forwardRef(function CircularProgress(props, ref) {
	const { className, size = 40, style, thickness = 7.2, ...other } = props

	return (
		<div
			ref={ref}
			role="progressbar"
			className={clsx('Vb-circularprogress', className)}
			style={{ width: size, height: size, ...style }}
			{...other}
		>
			<svg viewBox={`${SIZE / 2} ${SIZE / 2} ${SIZE} ${SIZE}`}>
				<circle
					className="circle-progress"
					cx={SIZE}
					cy={SIZE}
					r={(SIZE - thickness) / 2}
					fill="none"
					strokeWidth={thickness}
				/>
				<circle
					className="circle-background"
					cx={SIZE}
					cy={SIZE}
					r={(SIZE - thickness) / 2}
					fill="none"
					strokeWidth={thickness}
				/>
			</svg>
		</div>
	)
})

export default CircularProgress

CircularProgress.defaultProps = {
	size: 40,
	thickness: 7.2
}

CircularProgress.propTypes = {
	/**
	 * @ignore
	 */
	className: PropTypes.string,

	/**
	 * The size of the circle.
	 * If using a number, the pixel unit is assumed.
	 * If using a string, you need to provide the CSS unit, e.g '3rem'.
	 * @default 40
	 */
	size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

	/**
	 * @ignore
	 */
	style: PropTypes.object,

	/**
	 * The thickness of the circle.
	 * @default 7.2
	 */
	thickness: PropTypes.number
}
